import { render, staticRenderFns } from "./BindAgentMessageDialog.vue?vue&type=template&id=6b22fbfd&scoped=true"
import script from "./BindAgentMessageDialog.vue?vue&type=script&lang=js"
export * from "./BindAgentMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./BindAgentMessageDialog.vue?vue&type=style&index=0&id=6b22fbfd&prod&lang=scss&scoped=true"
import style1 from "./BindAgentMessageDialog.vue?vue&type=style&index=1&id=6b22fbfd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22fbfd",
  null
  
)

export default component.exports